import React from 'react'
import * as flightInfoTypes from '../../flightDetail/flightInfoTypes'
import flightDetails from '../../../containers/flightDetails';

const FlightInfoGeneric = (props) => {
    var moment = require('moment');

    let { selectedFlightInfo, direction } = props   
      
    if (selectedFlightInfo.warnings != null) {
        console.log('warnings');
        console.log(selectedFlightInfo.warnings)                                                //For component weight, directional based
        return (
            <div className="fullWidth">
            <div className="flightNumberDisplay">
                <div className="flightCode">
                    {
                    direction == 1 ? selectedFlightInfo.IATAMarketingcodeInbound : selectedFlightInfo.IATAMarketingcodeOutbound                    
                    }
                </div>
                <div className="flightNumber" >{selectedFlightInfo.fltNum} <span className="tailNumber">/ {selectedFlightInfo.tailNum}</span></div>
            </div>      
            <div className="cityTime">{selectedFlightInfo.depCity} - {selectedFlightInfo.arrCity} / {moment(selectedFlightInfo.time).format('HH:mm')} </div>
            <div className="clear"></div>
        </div>
        )
    } else {
        if(direction === '2')
        {
        //let flightNumber = selectedFlightInfo.direction === 'out' ? selectedFlightInfo.FltNumOutbound : selectedFlightInfo.FltNumInbound;
        let flightNumber =  selectedFlightInfo.FltNumOutbound;
        let departTime = moment(selectedFlightInfo.ETD_Outbound).format('HH:mm')
        //For others, only outbound
        return (

            <div className="fullWidth">
                <div className="flightNumberDisplay">
                    <div className="flightCode">{selectedFlightInfo.IATAMarketingcodeOutbound}</div>
                    <div className="flightNumber" >{flightNumber} <span className="tailNumber">/ {props.selectedFlightInfo.UncorrectedTailNum}</span></div>
                </div>
                <div className="cityTime">{props.selectedFlightInfo.DepAirportOutbound} - {props.selectedFlightInfo.ArrAirportOutbound} / {departTime} </div>
                <div className="clear"></div>
            </div>
        )
    }
    else{
        let flightNumber =  selectedFlightInfo.FltNumInbound;
        let departTime = moment(selectedFlightInfo.ETA_Inbound).format('HH:mm')
        //For others, only inbound
        return (
            <div className="fullWidth">
                <div className="flightNumberDisplay">
                    <div className="flightCode">{selectedFlightInfo.IATAMarketingcodeInbound}</div>
                    <div className="flightNumber" >{flightNumber} <span className="tailNumber">/ {props.selectedFlightInfo.UncorrectedTailNum}</span></div>
                </div>
                <div className="cityTime">{props.selectedFlightInfo.DepAirportInbound} - {props.selectedFlightInfo.DepAirportOutbound} / {departTime} </div>
                <div className="clear"></div>
            </div>
        )

    }
    }
}

export default FlightInfoGeneric